import { ArticleType } from '@nemuru-eng/js-api-client';
import { useMemo } from 'react';

import { AccommodationForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Accommodation/components/AccommodationForm';
import { AutomobileForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/components/AutomobileForm';
import { FlightForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Flight/components/FlightForm/FlightForm';
import { ProductForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Product/components/ProductForm';
import { ServiceForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Service/components/ServiceForm';
import { TravelForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Travel/components/TravelForm';
import { ArticleTypeDetailsFormWrapper } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartItemDialog/components/ArticleTypeDetailsFormWrapper';

interface ArticleTypeDetailsFormProps {
  articleType: ArticleType;
  loadingDetailsForm?: boolean;
}

const ArticleTypeDetailsFormFactory: Record<ArticleType, (props: any) => JSX.Element> = {
  [ArticleType.ONLINE_PRODUCT]: ProductForm,
  [ArticleType.SERVICE]: ServiceForm,
  [ArticleType.ACCOMMODATION]: AccommodationForm,
  [ArticleType.FLIGHT]: FlightForm,
  [ArticleType.TRAVEL]: TravelForm,
  [ArticleType.AUTOMOBILE]: AutomobileForm,
};

export const TypeDetailsForm = ({ articleType, loadingDetailsForm, ...props }: ArticleTypeDetailsFormProps) => {
  const ItemForm = useMemo(() => ArticleTypeDetailsFormFactory[articleType], [articleType]);

  return (
    <ArticleTypeDetailsFormWrapper {...props} loadingDetailsForm={loadingDetailsForm}>
      <ItemForm {...props} />
    </ArticleTypeDetailsFormWrapper>
  );
};
